<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementtree from '../lib/datetree/tree.vue'
	import mkcodeIndex from './lib/mkcode/index.vue'
	import receiptIndex from './lib/receipt/index.vue'
	export default {
		extends: listBase,
		name: 'reconciliationcurrentIndex',
		props: {

		},

	
		render(h) {
			this.$slots.mainheader = [
				<span style="padding-left:10px"><el-tag type="danger" size="small">已付款单据未完结</el-tag></span>,
				<span style="padding-left:10px"><el-tag type="danger" size="small">已付款单据已关闭</el-tag></span>,
				// <el-switch style="padding-left:20px" v-model={this.showError} onChange={this.errorChange} active-text="显示异常单据" inactive-text=""></el-switch>,
			]
			this.$slots.aside = [ <settlementtree ref = "settlementtree"key = {this.settlementtreeKey} onSelect = {this.settlementtreeChange}/>
			]
			this.$slots.plug = [
				<mkcode-index ref="McCodeBox" title={this.mkcodetitle} row={this.currentrow} onSuccess={this.McCodeBoxSuccess} />,
				<receipt-index ref="receiptBox" receiptInfo={this.receiptInfo} row={this.currentrow} />
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>{'现结对账'}</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				showError:false,
				asideWidth: 150,
				moduleName: 'reconciliationcurrent',
				windowName: '现结对账单',
				windowType: 'modal',
				settlementtreeKey: Math.random(),
				nodeid: [],
				parentbread: [],
				currentrow: null,
				currentrcvinfo: null,
				currentpayinfo:null,
				receiptInfo: null,		
				workorderForeingKey:{}
				
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.foreingKey.settlementtype = '8805,8825'
		},
		computed: {

		},

		methods: {
			workorder(item) {
				//console.log(item,item.purchasestockbillbiztime)
				this.$api.reconciliationcurrent.getrelationCode({
					purchasecode:item.purchasecode,
					purchasestockbillcode:item.purchasestockbillcode,
				}).then((res)=>{
					let grouppurchaseData = this.$Lodash.groupBy(res, 'purchasecode')
					let grouppurchasestockbillData = this.$Lodash.groupBy(res, 'purchasestockbillcode')
					let purchasecode = []
					let purchasestockbillcode = []
					let purchasesum = 0
					let purchasestockbilldebt = 0
					//console.log(grouppurchaseData,grouppurchasestockbillData)
					for(let i in grouppurchaseData){
						purchasecode.push(i)
						purchasesum += parseFloat(grouppurchaseData[i][0].purchasesum)
					}
					for(let i in grouppurchasestockbillData){
						purchasestockbillcode.push(i)
						purchasestockbilldebt += parseFloat(grouppurchasestockbillData[i][0].purchasestockbilldebt)
					}					
					this.$api.flow.getSingleFlowTemplate(19).then((e) => {
						if (e) {
							let res = this.$router.resolve({
								name: 'add',
								query: {
									name: 'reconciliationcurrentworkorder',
									id: 0,
									controlltype: 1,
									windowName: '采购单工单',
									extra: JSON.stringify({
										id: item.id,
										purchasecode: purchasecode.join(','),
										purchasestockbillstoragename: item.purchasestockbillstoragename,
										purchasebiztime: item.purchasebiztime,
										purchasesum: purchasesum.toFixed(2),
										purchasestockbillcode: purchasestockbillcode.join(','),
										purchasestockbillbiztime: item.purchasestockbillbiztime,
										purchasestockbilldebt: purchasestockbilldebt.toFixed(2),
										purchasecreatorname:item.purchasecreatorname,
										diffamount: (purchasesum - purchasestockbilldebt).toFixed(2)
									}),
									isflow: 1,
									flowid: 19
								}
							})
							if (this.device != 'pc') {
								this.$router.push(res.href.replace(/#/g, ''))
							} else {
								let win = window.open(res.href, item.formname + "add",
									this.$store.state.system.windowConfig)
								win.onload = () => {
									console.log(item.formname + 'form open')
								}
							}
								
						}
					})
				})

			},
			// cellClick({row}){
			// 	this.workorderForeingKey = {purchasecode:row.purchasecode}
			// 	this.$refs.reconciliationcurrentworkorder.customreload()
			// },
			// payment(row) {
			// 	this.currentrow = row
			// 	if(row.purchasesum>=1000){
			// 		this.$message.error('付款金额不能大于1000')
			// 		return
			// 	}
			// 	let handle = this.$loading()
			// 	this.$api[this.moduleName].getPaymentInfo({
			// 		supplierwlnid: row.purchasesupplierid
			// 	}).then((res) => {
			// 		this.$loadingclose(handle)
			// 		let payinfo = res.queryAccount[0]
			// 		let rcvinfo = res.supplierInfo
			// 		this.currentrcvinfo = rcvinfo
			// 		this.currentpayinfo = payinfo
			// 		let str = [
			// 			'付款公司：' + payinfo.accName,
			// 			'付款账号：' + payinfo.bankAcc,
			// 			'余额：' + payinfo.availBal,
			// 			'------------------------------------------',
			// 			'收款公司：' + rcvinfo.rcvName,
			// 			'收款账号：' + rcvinfo.rcvAcc,
			// 			'开户行：' + rcvinfo.rcvBankName,
			// 			'付款金额：' + (row.purchasefinbillsum>0?row.purchasefinbillsum: row.purchasesum),
			// 		]
			// 		console.log(str)
			// 		this.$confirm(str.join('</br>'), '付款信息', {
			// 			dangerouslyUseHTMLString:true,
			// 			confirmButtonText: '确定',
			// 			cancelButtonText: '取消',
			// 			type: 'warning',
			// 			beforeClose:this.beforePaySubmit
			// 		}).then(() => {
						
			// 		}).catch(() => {

			// 		});
			// 	},()=>{
			// 		this.$loadingclose(handle)
			// 	})

			// },
			beforePaySubmit(action, instance, done){
				if(action == 'confirm' && this.currentrow){
					//if(this.currentrcvinfo.rcvName  &&  this.currentrcvinfo.rcvAcc  && this.currentrcvinfo.rcvAcc){
						let handle = this.$loading()
						this.$api[this.moduleName].payment({
							billid: this.currentrow.id,
							supplierwlnid: this.currentrow.purchasesupplierid,
							payaccount: this.currentpayinfo.bankAcc,
							type:'CD'
						}).then(()=>{
							done()
							this.$loadingclose(handle)
							this.$message.success('操作成功')
						},()=>{
							this.$loadingclose(handle)
						})
					// }else{
					// 	this.$message.error('请完善供应商收款信息')
					// }
				}else{
					done()
				}
			},
			receipt(row) {
				this.currentrow = row
				let handle = this.$loading()
				this.$api.reconciliationcurrent.getReceiptInfo({
					supplierwlnid: row.purchasesupplierid,
					id: row.id,
					type: 'CD'
				}).then((res) => {
					this.receiptInfo = res
					this.$loadingclose(handle)
					this.$refs.receiptBox.modalShow()
					
				},()=>{
					this.$loadingclose(handle)
				})
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api[this.moduleName].settlement({
					id: row.id,
					wlnid: row.purchasesupplierid,
					purchasecode: row.purchasecode
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			settlementtreeChange(e) {
				this.parentbread = []
				this.nodeid = e.parentid != 0 ? [e.id] : e.childrenid
				if (e.parentid != 0) {
					this.parentbread.push({
						id: e.parentid,
						name: e.parentid
					})
				}
				this.parentbread.push({
					id: e.id,
					name: e.name
				})
				// this.gridOptions.pagerConfig = {
				// 	currentPage: 1,
				// 	pageSize: 20,
				// }
				this.customreload()
			},
			mkcode(row) {
				if (row.purchasefinbillcode) {
					this.mkcodetitle = row.purchasesuppliername
					this.currentrow = row
					console.log(this.currentrow)
					this.$refs.McCodeBox.modalShow()
				} else {
					this.$message.error('缺少预付款单编码')
				}
			},
			McCodeBoxSuccess() {
				this.customreload()
			},
			beforeRequest(form) {
				form.nodeid = this.nodeid
			},
			errorChange(e){
				this.foreingKey.error = e?1:0
				this.customreload()
			}
		},
		components: {
			mkcodeIndex,
			receiptIndex,
			
		}
	}
</script>